import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../../utils/redux';

export const consts = createReqConsts('auth', 'signup');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'invite_confirmations',
  slug: [
    {
      type: 'payload',
      selector: ['token'],
    },
  ],
  type: 'get',
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/auth/signup/signup-req.js